import { render, staticRenderFns } from "./PluginAlert.vue?vue&type=template&id=22a95dda"
import script from "./PluginAlert.vue?vue&type=script&lang=js"
export * from "./PluginAlert.vue?vue&type=script&lang=js"
import style0 from "./PluginAlert.vue?vue&type=style&index=0&id=22a95dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
